module.exports = __webpack_public_path__ + "img/p3.4699d9c3.png";